import React from 'react'
import { Link } from 'react-router-dom'
import 'less/sidebar.less'
import { connect } from 'react-redux'

const isSmScreenSize = () => window && window.innerWidth < 992

class Sidebar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      reduced: isSmScreenSize(),
    }
  }

  toggleReduced = () => {
    this.setState({ reduced: !this.state.reduced })
  }

  render() {
    const {
      links = [],
      header = 'InCrowd',
      subHeader = 'Interview',
    } = this.props

    const NavToggle = () =>
      <div onClick={this.toggleReduced} className="nav-toggle">
        <div className="hamburger-icon" />
      </div>

    const SidebarHeader = () =>
      <div className='sidebar-header'>
        <i className='apollo-logo' />
        <NavToggle />
      </div>

    return (
      <div id="shared-sidebar" className={this.state.reduced ? 'reduced' : ''}>
        <SidebarHeader />
        <div className='shared-sidebar-inner'>
          <SidebarHeader />
          <nav>
            {links.map((link, i) =>
              <Link className={`${link.className}`}
                key={i}
                to={link.path}
                onClick={() => isSmScreenSize() && this.setState({ reduced: true })}
              >
                <i className={`sidebar-icon ${link.icon}`} />
                <span className="link-display">{link.display}</span>
              </Link>
            )}
            <a onClick={this.props.logout}>
              <i className="sidebar-icon im-ss-lock" />
              <span>Logout</span>
            </a>
          </nav>
        </div>
      </div>
    )
  }
}

const mapDispatch = {
  logout: () => ({ type: 'LOGOUT' }),
}

export default connect(null, mapDispatch)(Sidebar)
